(function ($) {

    $(document).ready(function () {
        let lastScrollTop = 0;
        let header = $('#header');
        let viewportHeight = $(window).height();
        let scrollThreshold = 70;

        // hide and show header while scrolling
        $(window).scroll(function () {
            let currentScroll = $(this).scrollTop();

            if (currentScroll > scrollThreshold) {
                if (currentScroll > lastScrollTop) {
                    header.css('transform', 'translateY(-100%)'); // hide
                    header.css('background', 'transparent'); // hide
                    header.removeClass('sticky');

                } else {
                    header.css('transform', 'translateY(0)'); // show
                    header.addClass('sticky');
                    header.css('background', '#fff'); // hide
                }
            }

            if (currentScroll <= 70) {
                header.removeClass('sticky');
                header.css('background', 'transparent'); // hide
            }

            lastScrollTop = currentScroll;
        });


        // Open mobile menu
        $('.navbar-toggle').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('collapsed')) {
                $('.header').addClass('mobile-activated-menu');
                $('html').addClass('overflow-hidden'); // block scroll
                // $('#content').addClass('show-bg'); // block scroll
            } else {
                $('.header').removeClass('mobile-activated-menu');
                $('html').removeClass('overflow-hidden');
                // $('#content').removeClass('show-bg');
            }
        });
    });


})(jQuery);